/// <amd-module name="SuiteCommerce.MapAndContactUs.Main"/>
define("SuiteCommerce.MapAndContactUs.Main", ["require", "exports", "SuiteCommerce.MapAndContactInfoCCT", "SuiteCommerce.ContactUsFormCCT"], function (require, exports, MapAndContactInfoCCT, ContactUsFormCCT) {
    "use strict";
    return {
        mountToApp: function (container) {
            
            MapAndContactInfoCCT.mountToApp(container);
            ContactUsFormCCT.mountToApp(container);
        },
    };
});
